function convertFeetToInches(num) {
  let eq =
    "Converting " +
    num +
    " feet to inches: \n" +
    num +
    " * 12 = ";
  let rep = num * 12;
  return eq + rep.toFixed(2);
}

function convertFeetToYards(num) {
  let eq =
    "Converting " +
    num +
    " feet to yards: \n" +
    num +
    " * 0.33333 = ";
  let rep = num * 0.33333;
  return eq + rep.toFixed(3);
}

function convertFeetToMiles(num) {
  let eq =
    "Converting " +
    num +
    " feet to miles:  \n" +
    num +
    " * 0.00018939 = ";
  let rep = num * 0.00018939;
  return eq + rep.toFixed(6);
}

function convertFeetToMeters(num) {
  let eq =
    "Converting " +
    num +
    " feet to meters: \n" +
    num +
    " / 3.2808 = ";
  let rep = num / 3.2808;
  return eq + rep.toFixed(4);
}

function convertFeetToCM(num) {
  let eq =
    "Converting " +
    num +
    " feet to centimeters: \n" +
    num +
    " / 0.032808 = ";
  let rep = num / 0.032808;
  return eq + rep.toFixed(4);
}

function convertFeetToKilometers(num) {
  let eq =
    "Converting " +
    num +
    " feet to kilometers: \n" +
    num +
    " / 3280.8 = ";
  let rep = num / 3280.8;
  return eq + rep.toFixed(5);
}

export {
  convertFeetToInches,
  convertFeetToYards,
  convertFeetToMiles,
  convertFeetToMeters,
  convertFeetToCM,
  convertFeetToKilometers
};
